import { reactive } from 'vue';
const mainStore = reactive({
    brandId: 0,
    storeId: 0,
    adults: 0,
    children: 0,
    date: '',
    time: '',
});
export const MainStore = mainStore;
